// extracted by mini-css-extract-plugin
export var radioInputRow = "x_sW";
export var radioInputColumn = "x_sX";
export var inputOptionRow = "x_qq";
export var inputOptionColumn = "x_qr";